var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStackofCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "url(#pattern0_5145_7860)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_5145_7860",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5145_7860",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5145_7860",
    width: 50,
    height: 50,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB8klEQVR4nO2YMWgVQRCGDxtRBBHyuPkvUQmJIDYWVlY2FhIt3Zn3EghoYWORRrS0sbR/ggoSC0Fjk5BKTB3ERm1SCIIWwUZIOt8OrBxa+NTi7nbjHWQ+mPZnPu52bm+yzDAMwzASE+bppBcMVfA8przgycgV57O2UMaaCkKK8oLt1kS80ONUIsr0rjWRcAWH1RXXVXAnqvr5zeB61JqI0TXCpdmDKoWo4EZUMS2GASZaE/GCB8kOu+BtayIqWE82fhlfWxMJbmrWM5ZV6FVUMV6OHF1oTcToIqF/vBg5nIup8hX9Z7bDiUZ5CxOoJaGCpYR3rae/Z3vGvcjMpToiGwlFdv/I/hB3d8PryiK+n1/2jE+e6VtUCbZV6NaYCGPBM31plomyp7nKIoaxR3guLnqhregzwvS5/CcZy+7TVc/42OzM0VbZW2WRcjIkvGvtjGUL3v+3qaU///CSiCjjxdgTEdyPzLud1SG4fDr+y05nwt3swF/Zg8lTzfLy6VoSxn5a0IUBTnuhhw3zhuWFsxMLOmVsxmXSaicWdGUjceOcHnViQRfcsaO/tiz187i4FtzUocoixn5a0AXXO6KC+UZ5Lueyt04s6FSwEjkFh51Y0KngTWTmeicWdN958qwXetYkzzOWg/RmKosYhmEY2R7zA04PTQQUOmAwAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackofCoins);
export default __webpack_public_path__ + "static/media/StackofCoins.71fbb30a8585caf64b550fed08bf7f8a.svg";
export { ForwardRef as ReactComponent };